var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVioletM = function SvgVioletM(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69,
    height: 84,
    viewBox: "0 0 69 84",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "20.438%",
    x2: "79.091%",
    y1: "27.213%",
    y2: "82.661%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A175E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#985CD6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M101.496 29.43c-16.59 20.858-4.395 56.068-54.504 69.733-50.109 13.664-55.106 59.333-38.348 88.628 16.76 29.295 58.463 38.934 88.299 30.002 22.02-6.592 29.821-23.008 54.025-38.815 24.203-15.807 25.81-11.665 57.298-31.85 20.788-13.326 24.507-40.104 23.614-54.207C228.885 45.627 193.276-.004 153.449 0c-17.297.002-35.394 8.611-51.953 29.43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "20.438%",
    x2: "79.091%",
    y1: "43.558%",
    y2: "59.234%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A175E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#985CD6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.9,
    transform: "translate(0 -137)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M28 208.635c20.09 13.382 47.825 16.624 69.377 10.133 22.06-6.644 29.875-23.189 54.122-39.12 14.523-9.543 20.924-11.872 30.501-16.577C165.354 151.091 144.703 144 122.334 144c-43.652 0-80.76 27.005-94.334 64.635",
    mask: "url(#d)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVioletM);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/violet-m.cf7486d19857fa6739f667a554e5aa3b.svg";